import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from "react";
import Spinner from "~/components/Spinner";
import OnAirProvider from "./contexts/OnAir";
import OnAirPageDisplay from "./OnAirPageDisplay";
import useWebinar from "./hooks/useWebinar";
import { getPage, getShouldUseWebsocket, getTimePaddings } from "./utils";
var OnAir = function(param) {
    var isEmbedded = param.isEmbedded, webinarId = param.webinarId;
    var ref = useState(), webinar = ref[0], setWebinar = ref[1];
    var ref1 = useState(), invitation = ref1[0], setInvitation = ref1[1];
    // compute on update so time paddings are consistent throughout the app
    var ref2 = getTimePaddings(webinar), isStartingSoon = ref2.isStartingSoon, hasFinishedRecently = ref2.hasFinishedRecently;
    var page = getPage({
        isStartingSoon: isStartingSoon,
        isEmbedded: isEmbedded,
        webinar: webinar
    });
    var shouldUseWebsocket = getShouldUseWebsocket({
        hasFinishedRecently: hasFinishedRecently,
        isStartingSoon: isStartingSoon,
        page: page,
        webinar: webinar
    });
    var onMessage = function(data) {
        if (!data) return;
        if ("type" in data && data.type === "invitation") {
            var type = data.type, rest = _object_without_properties(data, [
                "type"
            ]);
            setInvitation(rest);
            return;
        }
        setWebinar(function(existing) {
            return _object_spread({}, existing || {}, data);
        });
    };
    var ref3;
    var ref4 = useWebinar({
        onMessage: onMessage,
        isViewerCountEnabled: (ref3 = webinar === null || webinar === void 0 ? void 0 : webinar.isViewerCountEnabled) !== null && ref3 !== void 0 ? ref3 : true,
        shouldUseWebsocket: shouldUseWebsocket,
        webinarId: webinarId
    }), refetchWebinar = ref4.refetch, getSubscribeSocket = ref4.getSocket;
    if (!webinar) {
        return /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx(Spinner, {
                id: "onair-loading-".concat(webinarId)
            })
        });
    }
    return /*#__PURE__*/ _jsx(OnAirProvider, {
        isEmbedded: isEmbedded,
        webinar: webinar,
        invitation: invitation,
        refetchWebinar: refetchWebinar,
        getSubscribeSocket: getSubscribeSocket,
        children: /*#__PURE__*/ _jsx(OnAirPageDisplay, {
            page: page,
            webinar: webinar
        })
    });
};
export default OnAir;
